import React, { ReactNode, FC, PropsWithChildren } from 'react';

import { theme } from '@lucid/theme';

import ThemeProvider from '../../theme-provider/theme-provider';
import ABTest from '../../ab-test/ab-test';
import buttons from './buttons';
import type { Lucid } from '../../../types/types';

interface UnifyCtaButtonsProps {
  children: ReactNode;
  product: Lucid.Product.Sites;
}

const ABTestThemeProviderUnifyCtaButtons: FC<PropsWithChildren<UnifyCtaButtonsProps>> = ({ children, product }) => {
  const alternativeTheme = Object.assign({}, theme);
  alternativeTheme.buttons = buttons as Lucid.Theme['buttons'];
  // De-risking to not run test in the unlikely event we don't have an alternative theme to pass in
  const shouldFallback = Object.keys(alternativeTheme).length === 0;

  return (
    <ABTest
      isAboveTheFold
      branchesToRender={['T_A', 'T_AN', 'T_B']}
      testName="Y22Q4_UnifiedSuiteCTAs"
      willTriggerFire={!shouldFallback}
    >
      <ABTest.Branch branch="T_A">
        <ThemeProvider product={product} theme={theme}>
          {children}
        </ThemeProvider>
      </ABTest.Branch>
      <ABTest.Branch branch="T_AN">
        <ThemeProvider product={product} theme={theme}>
          {children}
        </ThemeProvider>
      </ABTest.Branch>
      <ABTest.Branch branch="T_B">
        <ThemeProvider product={product} theme={alternativeTheme}>
          {children}
        </ThemeProvider>
      </ABTest.Branch>
    </ABTest>
  );
};

export default ABTestThemeProviderUnifyCtaButtons;
